// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"e74aea4d","256":"95bfd641","871":"4c034543"}[chunkId] + ".chunk.js";
};